export function calculateHaveCountTime(end, start) {
  const haveCountTime = end - start;

  if (haveCountTime > 0) {
    return haveCountTime / 1000;
  }

  return 0;
}
